import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\Root\\Documents\\source\\law\\frontend\\src\\components\\frontend\\awards\\AwardCard.tsx");
